// const authApi = `/api`
// const getApi = `/api/get`
// const postApi = `/api/post`
const api = `/api`
const AUTH = {
    LOGIN: `${api}/login`,
    GOOGLE_LOGIN: `${api}/google-login`,
    FORGOT_PASSWORD: `${api}/forgot-password`,
    RESET_PASSWORD: `${api}/reset-password`,
}

const GET = {
    VERIFY_TOKEN: `${api}/access_token`,
    DROPDOWN_OPTIONS: `${api}/get-dropdown-options`,
    GET_EMPLOYE_LOG: `${api}/get-employe-logs`,
    GET_EMPLOYEE_NAME: `${api}/get-employe-name`,
    GET_EMPLOYEE_PDF: `${api}/get-employee-pdf`,
    GET_SYSTEM_COLOUMN: `${api}/get-estimation-coloumns`,
    GET_ESTIMATION_DATA: `${api}/get-estimation-data`,
    GET_COMPONENTS: `${api}/get-components`,
    GET_VEHICLES: `${api}/get-vehicles`,
    GET_USERS: `${api}/get-users`,
    GET_LEAVE: `${api}/get-leaves`,
    GET_ALL_LEAVES: `${api}/get-all-leaves`,
    GET_ESTIMATION_STATS: `${api}/get-estimation-stats`,
    GET_LEAVE_PDF: `${api}/get-leave-pdf`,
    GET_ESTIMATION_PDF: `${api}/get-estimation-pdf`,
    GET_ESTIMATION_TOTAL: `${api}/get-estimation-total`,
    GET_APPROVED_LEAVE_DATES: `${api}/get-approved-leave-dates`,
    GET_EMPLOYEE_ANALYTICS: `${api}/get-employee-analytics`,
    GET_MAP_DATA: `${api}/get-map-data`,
    GET_PRODUCTS: `${api}/get-products`,
    GET_BUDGET_PROJECTS: `${api}/get-budget-projects`,
    GET_BUDGET_PROJECT: `${api}/get-budget-project`,
    IUBENDA_PRIVACY_POLICY: `${api}/iubenda-privacy-policy`,

}

const POST = {
    ADD_DROPDOWN: `${api}/add-dropdown`,
    DELETE_DROPDOWN: `${api}/delete-dropdown-option`,
    UPDATE_DROPDOWN: `${api}/update-dropdown-options`,
    ADD_EMPLOYEE_LOG: `${api}/add-employee-log`,
    CHECK_IN: `${api}/check-in`,
    ESTIMATION_ADD_COLUMN: `${api}/add-devices`,
    ESTIMATION_ADD_ROW: `${api}/add-units`,
    EDIT_ESTIMATION_DATA: `${api}/edit-estimation-data`,
    UPDATE_ESTIMATION_COMPONENT: `${api}/update-estimation-component`,
    DELETE_DEVICE: `${api}/delete-device`,
    DELETE_UNIT: `${api}/delete-unit`,
    ADD_VEHICLE: `${api}/add-vehicle`,
    EDIT_VEHICLE: `${api}/edit-vehicle`,
    DELETE_VEHICLE: `${api}/delete-vehicle`,
    ADD_USER: `${api}/add-user`,
    EDIT_USER: `${api}/edit-user`,
    DELETE_USER: `${api}/delete-user`,
    APPLY_LEAVE: `${api}/apply-leave`,
    UPDATE_LEAVE_STATUS: `${api}/update-leave-status`,
    UPDATE_DEVICE_NAME: `${api}/update-device-name`,
    UPDATE_EMPLOYEE_LOG: `${api}/update-employee-log`,
    UPDATE_PASSWORD: `${api}/update-password`,
    UPDATE_USER: `${api}/update-user`,
    UPDATE_DEVICE_QUANTITY: `${api}/update-device-quantity`,
    UPDATE_UNIT_PRICE: `${api}/update-unit-price`,
    ADD_BULK_UNITS: `${api}/add-bulk-units`,
    RESUME_WORK: `${api}/resume-work`,
    BREAK_TIME: `${api}/on-break`,
    GET_EMPLOYEE_WORK_LOG_AND_BREAKS: `${api}/get-employee-work-log-and-break`,
    ADD_EMPLOYEE_WORK_LOG_IN_ADMIN_WITH_BREAKS: `${api}/add-employee-work-log-in-admin-with-break`,
    ADD_PRODUCT: `${api}/add-product`,
    DELETE_PRODUCT: `${api}/delete-product`,
    UPDATE_PRODUCT: `${api}/update-product`,
    UPDATE_FCM_TOKEN: `${api}/update-fcm-token`,
    ADD_NOTE: `${api}/add-note`,
    UPDATE_NOTE: `${api}/update-note`,
    SAVE_BUDGET_PROJECT: `${api}/save-budget-project`,
    DELETE_BUDGET_PROJECT: `${api}/delete-budget-project`,
}

export {
    AUTH,
    GET,
    POST
}